module.exports = __webpack_public_path__ + "media/images/icons/icon-product_6-1ebfef15ad8e6a7c23caf251806f165b.svg";